module.exports = __webpack_public_path__ + "img/4.ee94250a.jpg";